// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"132":"62872ef0","801":"dc96c00d"}[chunkId] + ".chunk.css";
};